/*@ngInject*/
const PrequalificationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.cancelPrequalification = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/cancelPreQualification';

        return this.post(url);
    };

    this.startPrequalification = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/startPreQualification';

        return this.post(url);
    };

    this.submitPrequalification = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/submitPreQualification';

        return this.post(url);
    };

    this.checkPrequalification = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/checkPreQualification';

        return this.post(url);
    };

};

angular.module('gw-um-submission')
    .service('prequalificationRepository', PrequalificationRepository);
